// AI-CONTEXT: See docs/features/arbeidsvaardigheden.md
import { groeiPerEffect } from './groeiPerEffect'
import { gesorteerd } from './beoordelingDocument'

// De groei per thema zoals het tabblad Arbeidsvaardigheden en de
// rapportagewidget hem tonen. Nodig omdat beide dezelfde regels onder de
// themanaam en dezelfde toelichting moeten laten zien; los uitgeschreven
// zouden ze uit elkaar gaan lopen.

/** @param {number|null} score @returns {string} */
const scoreUI = (score) => (Number.isFinite(score) ? score.toFixed(1).replace('.', ',') : '—')

/**
 * @param {*} datum - yyyy-mm-dd
 * @returns {string} dd-mm-yyyy, of 'onbekende datum'
 */
export const datumUI = (datum) => {
    if (!datum) return 'onbekende datum'
    const [y, m, d] = String(datum).split('-')
    return `${d}-${m}-${y}`
}

/**
 * Regel onder de themanaam: het verloop, of waarom er nog geen verloop is.
 * @param {{groei: number|null, eerste: number|null, laatste: number|null, metingen: number}} rij - Rij uit groeiPerEffect
 * @returns {string}
 */
const groeiMeta = (rij) => {
    if (rij.groei !== null) return `${scoreUI(rij.eerste)} → ${scoreUI(rij.laatste)}`
    return rij.metingen === 1 ? 'pas één meting' : 'nog niet gemeten'
}

/**
 * @param {Array<object>} beoordelingen - WorkSkillsAssessments van één deelnemer, in elke volgorde
 * @returns {Array<import('../../components/personas/arbeidsvaardigheden/GroeiPerThema').GroeiRij>}
 */
export const groeiRijenVoorWeergave = (beoordelingen) =>
    groeiPerEffect(beoordelingen).map((rij) => ({
        id: rij.id,
        naam: rij.naam,
        groei: rij.groei,
        meta: groeiMeta(rij),
    }))

/**
 * @param {Array<object>} beoordelingen - Minstens één beoordeling, in elke volgorde
 * @returns {string}
 */
export const groeiToelichting = (beoordelingen) => {
    const lijst = gesorteerd(beoordelingen)
    return `eerste (${datumUI(lijst[lijst.length - 1].Datum)}) tot laatste (${datumUI(lijst[0].Datum)}) beoordeling`
}

const groeiWeergave = { groeiRijenVoorWeergave, groeiToelichting, datumUI }

export default groeiWeergave
